var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitationOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 57,
    viewBox: "0 0 82 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8047 0H18.6353L6.05647 22.1294C0.232941 32.3788 0 34.4753 0 38.6682C0 48.4518 8.15294 56.1388 18.4024 56.1388C28.4188 56.1388 36.5718 48.4518 36.5718 38.6682C36.5718 32.1459 33.0776 26.7882 25.6235 23.76L36.8047 0ZM81.0635 0H62.8941L50.3153 22.1294C44.4918 32.3788 44.2588 34.4753 44.2588 38.6682C44.2588 48.4518 52.4118 56.1388 62.6612 56.1388C72.6776 56.1388 80.8306 48.4518 80.8306 38.6682C80.8306 32.1459 77.3365 26.7882 69.8824 23.76L81.0635 0Z",
    fill: "#ECE6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitationOpen);
export default __webpack_public_path__ + "static/media/citation-open.bf374d5af71a1c07ea70bb708dd8d778.svg";
export { ForwardRef as ReactComponent };